var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex",
    },
    [
      _c(
        "v-navigation-drawer",
        {
          staticStyle: {
            "max-height": "calc(100vh - 57px)",
            "overflow-y": "scroll",
          },
          attrs: {
            value: true,
            relative: "",
            bottom: "",
            permanent: "",
            scrollable: "",
            "mini-variant": _vm.mini,
          },
          on: {
            "update:miniVariant": function ($event) {
              _vm.mini = $event
            },
            "update:mini-variant": function ($event) {
              _vm.mini = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex pa-2 align-center",
            },
            [
              _vm.mini
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.mini = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-magnify")])],
                    1
                  )
                : _c("v-autocomplete", {
                    attrs: {
                      label: "ค้นหา",
                      "hide-details": "",
                      items: _vm.networks,
                      clearable: "",
                    },
                    on: {
                      change: _vm.searchThread,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-magnify")])],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-auto mt-auto",
                  attrs: {
                    icon: "",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.mini = !_vm.mini
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "d-flex px-2",
          }),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-list",
            {
              attrs: {
                nav: "",
                dense: "",
                value: "selectedThread",
                mandatory: "",
              },
            },
            _vm._l(_vm.threads, function (thread, index) {
              return _c(
                "v-list-item",
                {
                  key: thread.thread_id,
                  attrs: {
                    "input-value": thread.thread_id == _vm.active.thread,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveThread(thread.thread_id)
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            dot: "",
                            bottom: "",
                            color: "red",
                            value: thread.notifications,
                            "offset-x": "5",
                            "offset-y": "5",
                          },
                        },
                        [
                          thread.participant_name
                            ? _c(
                                "v-avatar",
                                {
                                  attrs: {
                                    color: "indigo",
                                    size: "25",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "white--text text-sm",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          thread.participant_name
                                            .substring(0, 1)
                                            .toUpperCase()
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      thread.participant_name
                        ? _c("v-list-item-title", [
                            _vm._v(
                              "\n            " +
                                _vm._s(thread.participant_name.toUpperCase()) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item-subtitle",
                        {
                          staticClass: "d-flex align-items-baseline",
                        },
                        [
                          thread.messages.length > 0
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "text-truncate d-inline-block mr-2",
                                  staticStyle: {
                                    "max-width": "120px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      thread.messages[
                                        thread.messages.length - 1
                                      ].message
                                    ) + "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(
                            "\n            —\n            " +
                              _vm._s(
                                _vm.$moment(thread.last_message).fromNow()
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("agent-message-list", {
        staticClass: "flex-fill",
        attrs: {
          id: "message-container",
          messages: _vm.active_messages,
          participant: _vm.active.participant,
          participant_name: _vm.active.participant_name,
          is_loading: _vm.is_message_loading,
          me: _vm.agent_id,
        },
        on: {
          fetchNewMessage: _vm.fetchNewMessage,
          messageUpdated: _vm.messageUpdated,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }